import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const Refresh: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.094 15.0308L22.555 8.81982L20.625 10.7498C19.353 9.63182 17.71 8.99982 16 8.99982C12.14 8.99982 9 12.1398 9 15.9998C9 19.8598 12.14 22.9998 16 22.9998C18.491 22.9998 20.814 21.6588 22.063 19.5008L20.332 18.4998C19.439 20.0418 17.779 20.9998 16 20.9998C13.243 20.9998 11 18.7568 11 15.9998C11 13.2428 13.243 10.9998 16 10.9998C17.179 10.9998 18.311 11.4228 19.205 12.1698L16.883 14.4918L23.094 15.0308Z" />
  </SvgIcon>
);
